/**
 * Byte length of a string as the Korean SMS gateway counts it (SHCT-846).
 *
 * SOLAPI caps an LMS/MMS subject line at **40 bytes** and rejects anything longer with status 1014
 * ("제목은 40byte까지 사용 가능합니다"). The count is the Korean messaging convention, NOT UTF-8:
 * ASCII costs 1 byte and everything else — Hangul above all — costs 2. So 40 bytes is about 20
 * Korean characters, or 40 Latin letters/digits.
 *
 * That difference is the whole point of counting here rather than reusing `TextEncoder`: UTF-8 bills
 * Hangul at 3 bytes, which would cut the title to 13 characters and reject titles the carrier would
 * have accepted.
 *
 * Counting runs over code points (`for…of`), so a surrogate pair is one character rather than two.
 * Emoji are rejected separately by the form schema and never reach a message that ships.
 */
export const SMS_TITLE_MAX_BYTES = 40;

export function smsByteLength(value: string): number {
	let bytes = 0;
	for (const ch of value) {
		bytes += ch.codePointAt(0)! <= 0x7f ? 1 : 2;
	}
	return bytes;
}
